(function() {
    'use strict';
    
a3_cabin_reports.controller('AcknowledgeModalCtrl', AcknowledgeModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AcknowledgeModalCtrl
    * @description 
    * Warning Modal about unread mandatory memos
    * @ngInject
    */
    function AcknowledgeModalCtrl($scope, ScheduleAcknowledgeFactory, $route, $uibModalInstance) {

        $scope.ConfirmAcknowledge = ConfirmAcknowledge;
        $scope.cancel = cancel;
        $scope.showContent = 'confirm';
        $scope.responseObj = { success: false, message: '', Results: [] };
        $scope.results = [];

        function ConfirmAcknowledge(){
            $scope.showContent = 'loading';
            ScheduleAcknowledgeFactory.acknowledgeChanges()
                .then(res => handleSubmitResponse(res))
                .catch(res => handleSubmitResponse(res));
 
        }

        function handleSubmitResponse(res) {
            $scope.showContent = 'results';
            $scope.responseObj = res;
        }

        /**
        * Closes modal
        * @memberof ProposalInfoModalCtr
        */
        function cancel() {
            $uibModalInstance.close('cancel');

            if($scope.responseObj.success){
                $route.reload();
            }
            
        }
    }

    
})();